import './WifiConnection.css';

import React, { useState } from 'react';
import { type WifiNetwork } from '@lib/networkApiTypes';
import { messageBox } from '@src/style/style';
import { useWifiNetworks } from '@src/contexts';
import { ConnectButton, GoBackButton, PasswordInput } from './components';

interface WifiConnectionProps {
  wifiNetwork: WifiNetwork
  onCancel: () => void
  onWifiConnected: () => void
}

export const WifiConnection = ({ wifiNetwork, onCancel, onWifiConnected }: WifiConnectionProps): JSX.Element => {
  const { isConnectingToWifi, connectToWifi } = useWifiNetworks();

  const [password, setPassword] = useState<string>('');

  const attemptWifiConnection = (): void => {
    if (wifiNetwork.encryption === 'on' && password === '') {
      messageBox('Please enter a password before connecting.', 'warning');

      return;
    }

    void connectToWifi(wifiNetwork, password)
      .then(success => {
        if (success) {
          onWifiConnected();
        }
      });
  };

  return (
    <div id="wifi_connection">
      <GoBackButton onClick={onCancel} disabled={isConnectingToWifi} />
      <div id="wifi_connection_title">{`The Wi-Fi network "${wifiNetwork.ssid}" requires a password`}</div>
      <div id="wifi_connection_controls">
        {wifiNetwork.encryption === 'on' ? <PasswordInput onChange={setPassword} /> : null}
        <ConnectButton onClick={attemptWifiConnection} disabled={isConnectingToWifi} />
      </div>
    </div>
  );
};
